window.dataLayer = window.dataLayer || [];

function getItemsFromLineItems(lineItems) {
  const items = lineItems.map((item, index) => ({
    item_id: item.variant.sku,
    item_name: item.variant.product.title,
    index,
    item_brand: item.variant.product.vendor,
    price: item.variant.price.amount,
    item_quantity: item.quantity,
  }));

  return items;
}

function getItemsFromCollectionVariants(collection) {
  const items = collection.productVariants.map((item, index) => ({
    item_id: item.sku,
    item_name: item.product.title,
    index,
    item_brand: item.product.vendor,
    price: item.price.amount,
  }));

  return items;
}

function getItemFromCartLine(cartLine) {
  return {
    item_id: cartLine.merchandise.sku,
    item_name: cartLine.merchandise.product.title,
    item_brand: cartLine.merchandise.product.vendor,
    price: cartLine.merchandise.price.amount,
    item_quantity: cartLine.quantity,
  };
}

addEventListener('message', function (e) {
  if (!e.data.pixelEvent) return;

  const { event } = e.data;

  passToPosthog(event);

  switch (event.name) {
    case 'page_viewed':
      window.dataLayer.push({
        ...event.data,
      });
      break;
    case 'product_viewed':
      window.dataLayer.push({
        event: 'product_viewed',
        ecommerce: {
          currency: event.data.productVariant.price.currencyCode,
          value: event.data.productVariant.price.amount,
          items: [
            {
              item_id: event.data.productVariant.sku,
              item_name: event.data.productVariant.product.title,
              item_brand: event.data.productVariant.product.vendor,
              price: event.data.productVariant.price.amount,
            },
          ],
        },
      });
      break;
    case 'collection_viewed':
      window.dataLayer.push({
        event: 'collection_viewed',
        ecommerce: {
          item_list_id: event.data.collection.id,
          item_list_name: event.data.collection.title,
          currency: event.data.collection.productVariants.length
            ? event.data.collection.productVariants[0].price.currencyCode
            : undefined,
          items: getItemsFromCollectionVariants(event.data.collection),
        },
      });
      break;
    case 'search_submitted':
      window.dataLayer.push({
        event: 'search_submitted',
        ecommerce: { search_term: event.data.searchResult.query },
      });
      break;
    case 'product_added_to_cart':
      window.dataLayer.push({
        event: 'product_added_to_cart',
        ecommerce: {
          content_type: 'product',
          content_name: event.data.cartLine.merchandise.product.title,
          currency: event.data.cartLine.merchandise.price.currencyCode,
          value: event.data.cartLine.merchandise.price.amount,
          items: [getItemFromCartLine(event.data.cartLine)],
        },
      });
      break;
    case 'product_removed_from_cart':
      window.dataLayer.push({
        event: 'product_removed_from_cart',
        ecommerce: {
          currency: event.data.cartLine.merchandise.price.currencyCode,
          value: event.data.cartLine.merchandise.price.amount,
          items: [getItemFromCartLine(event.data.cartLine)],
        },
      });
      break;
    case 'cart_viewed':
      window.dataLayer.push({
        event: 'cart_viewed',
        ecommerce: {
          currency: event.data.cart.cost.totalAmount.currencyCode,
          value: event.data.cart.cost.totalAmount.amount,
          items: event.data.cart.lines.map(getItemFromCartLine),
        },
      });
      break;
    case 'checkout_started':
      window.dataLayer.push({
        event: 'checkout_started',
        ecommerce: {
          currency: event.data.checkout.currencyCode,
          value: event.data.checkout.totalPrice.amount,
          coupon: event.data.checkout.coupon,
          items: getItemsFromLineItems(event.data.checkout.lineItems),
        },
      });
      break;
    case 'payment_info_submitted':
      window.dataLayer.push({
        event: 'payment_info_submitted',
        ecommerce: {
          currency: event.data.checkout.currencyCode,
          value: event.data.checkout.totalPrice.amount,
          items: getItemsFromLineItems(event.data.checkout.lineItems),
        },
      });
      break;
    case 'checkout_contact_info_submitted':
      window.dataLayer.push({
        event: 'checkout_contact_info_submitted',
        ecommerce: {
          currency: event.data.checkout.currencyCode,
          value: event.data.checkout.totalPrice.amount,
          items: getItemsFromLineItems(event.data.checkout.lineItems),
          address: event.data.checkout.shippingAddress,
        },
      });
      break;
    case 'checkout_completed':
      window.dataLayer.push({
        event: 'checkout_completed',
        ecommerce: {
          transaction_id: event.data.checkout.order.id,
          currency: event.data.checkout.currencyCode,
          value: event.data.checkout.totalPrice.amount,
          items: getItemsFromLineItems(event.data.checkout.lineItems),
        },
      });
      break;
    default:
      window.dataLayer.push({ event: 'unknown_event', data: event });
      break;
  }
});

function formatCurrency(amount, currency = 'GBP') {
  return parseFloat((amount / 100).toFixed(2));
}

function formatProduct(variant) {
  return {
    product_id: variant.product.id,
    product_name: variant.product.title,
    product_brand: variant.product.vendor,
    product_category: variant.product.type,
    product_variant_id: variant.id,
    product_variant_name: variant.title,
    sku: variant.sku,
    price: variant.price.amount,
    currency: variant.price.currencyCode || 'GBP',
  };
}

// Map Shopify events to PostHog standard events
const eventMapping = {
  page_viewed: '$pageview',
  product_viewed: 'Product Viewed',
  product_added_to_cart: 'Product Added',
  product_removed_from_cart: 'Product Removed',
  cart_viewed: 'Cart Viewed',
  checkout_started: 'Checkout Started',
  checkout_completed: 'Order Completed',
  checkout_contact_info_submitted: 'Checkout Step Completed',
  checkout_address_info_submitted: 'Checkout Step Completed',
  checkout_shipping_info_submitted: 'Checkout Step Completed',
  payment_info_submitted: 'Payment Info Entered',
  collection_viewed: 'Collection Viewed',
  search_submitted: 'Products Searched',
};

function formatEventData(shopifyEvent) {
  const eventName = eventMapping[shopifyEvent.name] || shopifyEvent.name;
  const data = shopifyEvent.data || {};
  let properties = {};

  switch (shopifyEvent.name) {
    case 'page_viewed':
      properties = {
        page_title: shopifyEvent.context.document.title,
        referrer: shopifyEvent.context.document.referrer,
      };
      break;

    case 'product_viewed':
      const product = formatProduct(data.productVariant);
      properties = {
        ...product,
        page_title: shopifyEvent.context.document.title,
        referrer: shopifyEvent.context.document.referrer,
      };
      break;

    case 'product_added_to_cart':
    case 'product_removed_from_cart':
      const cartProduct = formatProduct(data.cartLine.merchandise);
      properties = {
        ...cartProduct,
        quantity: data.cartLine.quantity || 1,
      };
      break;

    case 'cart_viewed':
      properties = {
        cart_id: data.cart.id,
        cart_total: data.cart.cost.totalAmount.amount,
        currency: data.cart.cost.totalAmount.currencyCode || 'GBP',
        num_items: data.cart.lines.length || 0,
        items: data.cart.lines.map((item) => formatProduct(item.merchandise)) || [],
      };
      break;

    case 'checkout_started':
      properties = {
        order_id: data.checkout.token,
        checkout_id: data.checkout.token,
        revenue: data.checkout.totalPrice.amount,
        currency: data.checkout.totalPrice.currencyCode || 'GBP',
        num_items: data.checkout.lineItems?.length || 0,
        items: data.checkout.lineItems?.map((item) => formatProduct(item.variant)) || [],
        tax: data.checkout.totalTax.amount,
      };
      break;

    case 'checkout_completed':
      properties = {
        order_id: data.checkout.order?.id,
        checkout_id: data.checkout.token,
        revenue: data.checkout.totalPrice.amount,
        currency: data.checkout.totalPrice.currencyCode || 'GBP',
        num_items: data.checkout.lineItems?.length || 0,
        items: data.checkout.lineItems?.map((item) => formatProduct(item.variant)) || [],
        shipping: data.checkout.shippingLine?.price?.amount,
        tax: data.checkout.totalTax.amount,
      };
      break;

    case 'checkout_contact_info_submitted':
      properties = {
        checkout_step: 'contact_info',
        checkout_id: data.checkout.token,
      };
      break;

    case 'checkout_address_info_submitted':
      properties = {
        checkout_step: 'address_info',
        checkout_id: data.checkout.token,
        shipping_country: data.checkout.shippingAddress?.country,
        shipping_city: data.checkout.shippingAddress?.city,
        shipping_state: data.checkout.shippingAddress?.province,
        shipping_zip: data.checkout.shippingAddress?.zip,
      };
      break;

    case 'checkout_shipping_info_submitted':
      properties = {
        checkout_step: 'shipping_info',
        checkout_id: data.checkout.token,
        shipping_country: data.checkout.shippingAddress?.country,
        shipping_city: data.checkout.shippingAddress?.city,
        shipping_state: data.checkout.shippingAddress?.province,
        shipping_zip: data.checkout.shippingAddress?.zip,
        shipping_method: data.shippingLine?.title,
        shipping_price: data.shippingLine?.price ? formatCurrency(data.shippingLine.price, data.currency) : undefined,
      };
      break;

    case 'collection_viewed':
      properties = {
        collection_id: data.collection.id,
        collection_name: data.collection.title,
      };
      break;

    case 'search_submitted':
      properties = {
        search_term: data.searchResult.query,
        search_results_count: data.searchResult.productVariants.length || 0,
      };
      break;

    default:
      // For unmapped events, clean up the data structure
      properties = {
        event_source: 'shopify_web_pixel',
        ...data,
      };
  }

  return { eventName, properties };
}

// Subscribe to Shopify analytics events
const trackedEvents = [
  'page_viewed',
  'product_viewed',
  'product_added_to_cart',
  'product_removed_from_cart',
  'cart_viewed',
  'checkout_started',
  'checkout_completed',
  'checkout_contact_info_submitted',
  'checkout_address_info_submitted',
  'checkout_shipping_info_submitted',
  'payment_info_submitted',
];

function passToPosthog(shopifyEvent) {
  return false; // Disable PostHog tracking for now
  if (!trackedEvents.includes(shopifyEvent.name)) return;

  try {
    const { eventName, properties, clientId } = formatEventData(shopifyEvent);

    posthog.identify(clientId);

    // Send to PostHog
    posthog.capture(eventName, properties);

    // Optional: Log for debugging
    console.log('PostHog Event:', eventName, properties);
  } catch (error) {
    console.error('PostHog tracking error:', error);
  }
}
